export default __webpack_public_path__ + "static/display-cd5ac940580c0f844cbdc77b1eef0f1c.jpg";